import React from 'react';
import { SIGNER_ROLES, SIGNER_ROLE_LABELS } from '../../utils/staffDocuments';
import './staffDocuments.css';

// Which roles sign a document. At least one stays ticked.
export default function WhoSigns({ value, onChange, disabled }) {
  const toggle = role => {
    const next = value.includes(role) ? value.filter(r => r !== role) : [...value, role];
    if (next.length > 0) onChange(SIGNER_ROLES.filter(r => next.includes(r)));
  };
  return (
    <fieldset className="sd-who">
      <legend>Who signs</legend>
      {SIGNER_ROLES.map(role => (
        <label key={role} className="sd-check">
          <input type="checkbox" className="bk-checkbox" checked={value.includes(role)} disabled={disabled}
            onChange={() => toggle(role)} />
          {SIGNER_ROLE_LABELS[role]}
        </label>
      ))}
    </fieldset>
  );
}
